const adminUserConstantsAr = {
  adminUserUserManagementBreadcrumbs: 'إدارة المستخدمين',
  adminUserBreadcrumbsUpdate: 'تحديث المستخدم',
  adminUserCreateHeaderTitle: 'إنشاء مستخدم',
  adminUserEditHeaderTitle: 'تحرير',
  adminUserSubtitle1: 'معلومات مستخدم سيما',
  adminUserSubtitle2: 'دور مستخدم سيما',
  adminUserSubtitle3: 'أذونات مستخدم سيما',
  adminUserEmailLabel: 'البريد الإلكتروني للمستخدم',
  adminUserFirstNameLabel: 'الاسم الأول',
  adminUserLastNameLabel: 'الاسم الاخير',
  adminUserPasswordLabel: 'كلمة المرور',
  adminUserConfirmPasswordLabel: 'تأكيد كلمة المرور',
  adminUserRoleLabel: 'دور المستخدم',
  adminUserRoleOption1: 'مدير',
  adminUserRoleOption2: 'مدخل بيانات',
  adminUserSaveButton: 'حفظ',
  adminUserCreateButton: 'إنشاء مستخدم',
  adminCreatedSuccessfully: 'تم إنشاء المستخدم بنجاح',
  existedEmailValidationError: 'هذا البريد الإلكتروني مسجل بالفعل، حاول استخدام بريد آخر',
};

export default adminUserConstantsAr;
